import { PatientCareCenterAl } from 'PatientCareCenter/Al';
import React from 'react';
import { connect } from 'react-redux'
import styles from './ActivityLogTab.module.css'

class ActivityLogTab extends React.Component {
    render() {
        return (
            <div className={styles.al_wrapper}>
                <PatientCareCenterAl epno={this.props.epno} mcWrapper={true} />
            </div>
        );
    }
}


function mapStateToProps(state) {
    return {
        epno: state.entities.notesReqApproval[state.ui.notesReqApproval.selectedMessage].epno
    };
}


const connectedActivityLogTab = connect(mapStateToProps)(ActivityLogTab);
export { connectedActivityLogTab as ActivityLogTab };
